var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffectOnce } from 'react-use';
import { useLazyPaginatedEndpoint, } from '../useLazyPaginatedEndpoint';
/**
 * Represents a hook that simplifies working with paginated endpoints. It
 * encapsulates the items, while exposing functions for navigating the pages,
 * changing the arg, re-fetching, updating an item, and more.
 */
export const usePaginatedEndpoint = (_a) => {
    var { initialArg } = _a, options = __rest(_a, ["initialArg"]);
    const result = useLazyPaginatedEndpoint(options);
    useEffectOnce(() => {
        result.changeArg(initialArg);
    });
    return result;
};
